import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
//importación de la clase Firebase
import Firebase, { FirebaseContext } from "./server";
//session provider (reducers/sessionReducer - session/initialSession - session/store)
import { initialState } from "./session/initialState";
import { SessionProvider } from "./session/store";
//import sessionReducer from './session/reducers/sessionReducer';
import { mainReducer } from "./session/reducers/";

//hacer global firebase para el proyecto mediante context de react para que pueda ser consumido por cualquier componente de la apicación y se configura en el archivo context.js
//const FirebaseContext = React.createContext();

ReactDOM.render(
  <React.StrictMode>
    <FirebaseContext.Provider value={new Firebase()}>
      <SessionProvider initialState={initialState} reducer={mainReducer}>
        <App />
      </SessionProvider>
    </FirebaseContext.Provider>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

/*******Instalación de firebase***********/
//npm install -g firebase-tools
//firebase login
//firebase init
/********Tras la confifuración de archivos incluidos en el server: context, firebase, index.js e index js de la app, instalar la librerias de firebase con: npm install --save firebase */
//instalar recompose para poder incluir el consumer de firebase en cada componente npm i recompose
